import React from "react";
// import Typewriter from "typewriter-effect";
import styled from "styled-components";
import { useDencrypt } from "use-dencrypt-effect";
import { useEffect } from 'react';

const MyTitleMessage = styled.h1`
  position: absolute;
  width: 100%;
  top: 22rem;
  z-index: 1;
  margin-top: -125px;
  text-align: center;

   strong {
     font-size: 1.25em;
  }
  div {
    color: aqua;

    text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
    font-weight: 100;
    letter-spacing: 7px;

    .main {
      font-size: 50px;
    }

    .sub {
      font-size: 27px;
      letter-spacing: 2px;
    }
  }
`;
const values = ["MERN Stack Web Developer", "Problem Solver", "Learner"];
const TitleMessage = () => {
  const { result, dencrypt } = useDencrypt();  
  useEffect(()=>{
    let i = 0; 
      const action = setInterval(() => {
        dencrypt(values[i]);
        if(i === values.length - 1){
          i = 0;
          } 
          else{
            i = i+1;
          }
      }, 3000);
      return () => clearInterval(action);
  }, [dencrypt])
  return (
  <MyTitleMessage>
    <div className="titleMessage">
      <div className="heading">
        <div className="main text-center mb-2" variant='primary'>
          Hi, I'm
          <br />
          <span>
            <strong>Md. Faizur Rahman Khan</strong>
          </span>
        </div>
        <div className="sub">
        <span style={{color:"aqua"}}> {result} </span>
        </div>
      </div>
    </div>
  </MyTitleMessage>
);
}

export default TitleMessage;
